export const BACKEND_URL = process.env["REACT_APP_BACKEND_URL"];
if (!BACKEND_URL) {
    console.log("No backend url string. Set REACT_APP_BACKEND_URL environment variable.");
    process.exit(1);
}


export const POST_URL = process.env["REACT_APP_POST_URL"];
export const REPROCESS_URL = process.env["REACT_APP_REPROCESS_URL"];


export const BASE_PATH = "/"